/**
 * Created by minimus on 02.01.2015.
 */
let sam = /*sam ||*/ {};
(function ($) {
  let media;
  const mediaTexts = options.media;
  const opts = options.strings;
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  const localeStrings = options.strings;
  const SAM_PRO_IS_HOME = 1;
  const SAM_PRO_IS_SINGULAR = 2;
  const SAM_PRO_IS_SINGLE = 4;
  const SAM_PRO_IS_PAGE = 8;
  const SAM_PRO_IS_ATTACHMENT = 16;
  const SAM_PRO_IS_SEARCH = 32;
  const SAM_PRO_IS_404 = 64;
  const SAM_PRO_IS_ARCHIVE = 128;
  const SAM_PRO_IS_TAX = 256;
  const SAM_PRO_IS_CATEGORY = 512;
  const SAM_PRO_IS_TAG = 1024;
  const SAM_PRO_IS_AUTHOR = 2048;
  const SAM_PRO_IS_DATE = 4096;
  const SAM_PRO_IS_POST_TYPE = 8192;
  const SAM_PRO_IS_POST_TYPE_ARCHIVE = 16384;
  const pageTypes = [
    SAM_PRO_IS_HOME,
    SAM_PRO_IS_SINGULAR,
    SAM_PRO_IS_SINGLE,
    SAM_PRO_IS_PAGE,
    SAM_PRO_IS_POST_TYPE,
    SAM_PRO_IS_ATTACHMENT,
    SAM_PRO_IS_SEARCH,
    SAM_PRO_IS_404,
    SAM_PRO_IS_ARCHIVE,
    SAM_PRO_IS_TAX,
    SAM_PRO_IS_CATEGORY,
    SAM_PRO_IS_TAG,
    SAM_PRO_IS_AUTHOR,
    SAM_PRO_IS_POST_TYPE_ARCHIVE,
    SAM_PRO_IS_DATE
  ];
  //let dataTarget;
  sam.media = media = {
    buttonId: '#banner-media',
    adUrl: '#img',
    adImgId: '#img_id',
    adName: '#title',
    adDesc: '#description',
    adLink: '#link',
    adAlt: '#alt',
    adFallback: '#swf_fallback',
    btnFallback: '#fallback-code',

    init: function () {
      $(this.buttonId).on('click', this.openMediaDialog);
      $(this.btnFallback).on('click', this.openMediaDialog);
    },

    openMediaDialog: function (e) {
      e.preventDefault();
      const btnId = '#' + e.currentTarget.id;

      if (this._frame) {
        this._frame.open();
        return;
      }

      this._frame = media.frame = wp.media({
        title: mediaTexts.title,
        button: {
          text: mediaTexts.button
        },
        multiple: false,
        library: {
          type: 'image'
        }
      });

      this._frame.state('library').on('select', function () {
        const attachment = this.get('selection').single();
        media.handleMediaAttachment(attachment, btnId);
      });

      this._frame.open();
    },

    handleMediaAttachment: function (a, id) {
      const attachment = a.toJSON();
      if(id === this.buttonId) {
        $(this.adUrl).val(attachment.url);
        $(this.adImgId).val(attachment.id);
        if ('' === $(this.adName).val() && '' !== attachment.title) $(this.adName).val(attachment.title);
        if ('' === $(this.adDesc).val() && '' !== attachment.caption) $(this.adDesc).val(attachment.caption);
        if ('' === $(this.adAlt).val() && '' !== attachment.alt) $(this.adAlt).val(attachment.alt);
      }
      else if(id === this.btnFallback) {
        const
          target = $(this.adLink).val(),
          anchor = (target !== '') ? '<a href="' + target + '">' : '',
          image = '<img src="' + attachment.url + '">',
          anchorE = (target !== '') ? '</a>' : '',
          code = anchor + image + anchorE;
        $(this.adFallback).val(code);
      }
    }
  };

  function getTypes(x) {
    let out = [];
    pageTypes.forEach((e, i) => {
      if (x & e) out.push(i);
    });
    return out;
  }

  function setTypes(x, types) {
    let out = types;
    x.forEach((e, i) => (out |= parseInt(e.id, 10)));
    return out;
  }

  function removeTypes(x, types, parent) {
    let out = types;
    const p = parseInt(parent, 10);
    x.forEach((e) => out = (out & ~ parseInt(e.id, 10)));
    out = (out & ~ p);
    return out;
  }

  $(document).ready(function () {
    $('#tabs').ejTab({enablePersistence: true});
    media.init();

    const rccmf = $('#rc-cmf');
    const rccmt = $('#rc-cmt');
    $('#amode_false').click(function () {
      rccmf.show('blind', {direction: 'vertical'}, 500);
      rccmt.hide('blind', {direction: 'vertical'}, 500);
    });

    $('#amode_true').click(function () {
      rccmf.hide('blind', {direction: 'vertical'}, 500);
      rccmt.show('blind', {direction: 'vertical'}, 500);
    });

    const pageTypesT = $('#ptypes');
    let aTypes = parseInt(pageTypesT.val(), 10) || 0;
    const ptypes = $('#page-types').ejTreeView({
      showCheckbox: true,
      checkedNodes: getTypes(aTypes/*parseInt(pageTypesT.val(), 10)*/),
      nodeCheck: function (args) {
        aTypes = setTypes(args.currentCheckedNodes, aTypes, args.parentId);
        pageTypesT.val(aTypes);
      },
      nodeUncheck: function (args) {
        aTypes = removeTypes(args.currentUncheckedNodes, aTypes, args.parentId);
        pageTypesT.val(aTypes);
      }
    }).data('ejTreeView');
    ptypes.expandAll();

    const rcvt = $('#rc-vt0');
    $("input:radio[name=ptype]").on('click', function() {
      const cval = parseInt($('input:radio[name=ptype]:checked').val(), 10);
      if(cval === 0) {
        if (rcvt.is(':visible')) rcvt.hide('blind', {direction:'vertical'}, 500);
      }
      else if(cval === 1) {
        if (rcvt.is(':hidden')) rcvt.show('blind', {direction:'vertical'}, 500);
      }
    });

    const rcposts = $('#rc-posts');
    const eposts = $('#eposts');
    const rccats = $('#rc-cats');
    const ecats = $('#ecats');
    const rctags = $('#rc-tags');
    const etags = $('#etags');
    const rcauthors = $('#rc-authors');
    const eauthors = $('#eauthors');
    const rctax = $('#rc-tax');
    const etax = $('#etax');
    const rctypes = $('#rc-types');
    const etypes = $('#etypes');
    const rcSchedule = $('#rc-schedule');
    const sch = $('#schedule');
    const rchl = $('#rc-hl');
    const hl = $('#limit_hits');
    const rccl = $('#rc-cl');
    const cl = $('#limit_clicks');

    eposts.on('click', function() {
      if(eposts.is(':checked')) rcposts.show('blind', {direction:'vertical'}, 500);
      else rcposts.hide('blind', {direction:'vertical'}, 500);
    });
    ecats.on('click', function() {
      if(ecats.is(':checked')) rccats.show('blind', {direction:'vertical'}, 500);
      else rccats.hide('blind', {direction:'vertical'}, 500);
    });
    etags.on('click', function() {
      if(etags.is(':checked')) rctags.show('blind', {direction:'vertical'}, 500);
      else rctags.hide('blind', {direction:'vertical'}, 500);
    });
    eauthors.on('click', function() {
      if(eauthors.is(':checked')) rcauthors.show('blind', {direction:'vertical'}, 500);
      else rcauthors.hide('blind', {direction:'vertical'}, 500);
    });
    etax.on('click', function() {
      if(etax.is(':checked')) rctax.show('blind', {direction:'vertical'}, 500);
      else rctax.hide('blind', {direction:'vertical'}, 500);
    });
    etypes.on('click', function() {
      if(etypes.is(':checked')) rctypes.show('blind', {direction:'vertical'}, 500);
      else rctypes.hide('blind', {direction:'vertical'}, 500);
    });

    sch.on('click', function() {
      if(sch.is(':checked')) rcSchedule.show('blind', {direction:'vertical'}, 500);
      else rcSchedule.hide('blind', {direction:'vertical'}, 500);
    });

    hl.on('click', function() {
      if(hl.is(':checked')) rchl.show('blind', {direction:'vertical'}, 500);
      else rchl.hide('blind', {direction:'vertical'}, 500);
    });

    cl.on('click', function() {
      if(cl.is(':checked')) rccl.show('blind', {direction:'vertical'}, 500);
      else rccl.hide('blind', {direction:'vertical'}, 500);
    });

    const dlgOptions = {
      width: 830,
      allowDraggable: true,
      enableModal: true,
      showOnInit: false
    };
    const postsDialog = $('#postsDialog').ejDialog(dlgOptions).data('ejDialog');
    const catsDialog = $('#catsDialog').ejDialog(dlgOptions).data('ejDialog');
    const tagsDialog = $('#tagsDialog').ejDialog(dlgOptions).data('ejDialog');
    const authorsDialog = $('#authorsDialog').ejDialog(dlgOptions).data('ejDialog');
    const taxDialog = $('#taxDialog').ejDialog(dlgOptions).data('ejDialog');
    const typesDialog = $('#typesDialog').ejDialog(dlgOptions).data('ejDialog');

    // Selectors
    const posts = $('#posts');
    const postsSel = new Selectors();
    postsSel.sid = posts.val();

    const cats = $('#cats');
    const catsSel = new Selectors();
    catsSel.sid = cats.val();

    const tags = $('#tags');
    const tagsSel = new Selectors();
    tagsSel.sid = tags.val();

    const authors = $('#authors');
    const authSel = new Selectors();
    authSel.sid = authors.val();

    const taxes = $('#taxes');
    const taxSel = new Selectors();
    taxSel.sid = taxes.val();

    const types = $('#types');
    const typesSel = new Selectors();
    typesSel.sid = types.val();

    // Grids
    const sPost = encodeURI(opts.posts);
    const sPage = encodeURI(opts.page);
    const dmPosts = ej.DataManager({
      url: `${ajaxurl}?action=load_posts&cstr=${options.data.custList}&sam_pro_nonce=${options.samProNonce}&sp=${sPost}&spg=${sPage}${(posts.val() === '') ? '' : `&ids=${posts.val()}`}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmCats = ej.DataManager({
      url: `${ajaxurl}?action=load_cats&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmTags = ej.DataManager({
      url: `${ajaxurl}?action=load_tags&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmAuth = ej.DataManager({
      url: `${ajaxurl}?action=load_authors&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmTax = ej.DataManager({
      url: `${ajaxurl}?action=load_taxes&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmTypes = ej.DataManager({
      url: `${ajaxurl}?action=load_types&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });

    const postsGrid = $('#postsGrid').ejGrid({
      dataSource: dmPosts,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: options.itemsPerPage
      },
      columns: [
        {field: 'id', headerText: 'ID', textAlign: ej.TextAlign.Right, width: 70},
        {field: 'title', headerText: localeStrings.name, width: 480},
        {field: 'type', headerText: localeStrings.type, width: 250}
      ],
      rowSelected: function (args) {
        if (!postsSel.service) {
          postsSel.page = args.model.pageSettings.currentPage;
          const d = postsSel.pids[postsSel.page].slice(0);
          const cr = d.indexOf(args.data.id);
          if (cr > -1) postsSel.removePid(args.data.id);
          else postsSel.pids = args.data.id;
        }
      },
      actionComplete: function (args) {
        const d = postsSel.ids.slice(0);
        postsSel.service = true;
        if (d.length !== 0) {
          for (let i = 0; i < this.model.currentViewData.length; i++) {
            for (let j = 0; j < d.length; j++) {
              if (d[j] === this.model.currentViewData[i].id) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if (args.requestType === 'paging') {
                  postsSel.page = args.currentPage;
                  postsSel.pids = this.model.currentViewData[i].id;
                }
                else if (args.requestType === 'refresh') {
                  postsSel.page = 1;
                  postsSel.pids = this.model.currentViewData[i].id;
                }
              }
            }
          }
        }
        postsSel.service = false;
      }
    }).data('ejGrid');

    const catsGrid = $('#catsGrid').ejGrid({
      dataSource: dmCats,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: options.itemsPerPage
      },
      columns: [
        {field: 'id', headerText: 'ID', textAlign: ej.TextAlign.Right, width: 70},
        {field: 'title', headerText: localeStrings.name, width: 480},
        {field: 'slug', headerText: localeStrings.slug, width: 250}
      ],
      rowSelected: function (args) {
        if (!catsSel.service) {
          catsSel.page = args.model.pageSettings.currentPage;
          const d = catsSel.pids[catsSel.page].slice(0);
          const cr = d.indexOf(args.data.slug);
          if (cr > -1) catsSel.removePid(args.data.slug);
          else catsSel.pids = args.data.slug;
        }
      },
      actionComplete: function (args) {
        const d = catsSel.ids.slice(0);
        catsSel.service = true;
        if (d.length !== 0) {
          for (let i = 0; i < this.model.currentViewData.length; i++) {
            for (let j = 0; j < d.length; j++) {
              if (d[j] === this.model.currentViewData[i].slug) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if (args.requestType === 'paging') {
                  catsSel.page = args.currentPage;
                  catsSel.pids = this.model.currentViewData[i].slug;
                }
                else if (args.requestType === 'refresh') {
                  catsSel.page = 1;
                  catsSel.pids = this.model.currentViewData[i].slug;
                }
              }
            }
          }
        }
        catsSel.service = false;
      }
    }).data('ejGrid');

    const tagsGrid = $('#tagsGrid').ejGrid({
      dataSource: dmTags,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: options.itemsPerPage
      },
      columns: [
        {field: 'id', headerText: 'ID', textAlign: ej.TextAlign.Right, width: 70},
        {field: 'title', headerText: localeStrings.name, width: 480},
        {field: 'slug', headerText: localeStrings.slug, width: 250}
      ],
      rowSelected: function (args) {
        if (!tagsSel.service) {
          tagsSel.page = args.model.pageSettings.currentPage;
          const d = tagsSel.pids[tagsSel.page].slice(0);
          const cr = d.indexOf(args.data.slug);
          if (cr > -1) tagsSel.removePid(args.data.slug);
          else tagsSel.pids = args.data.slug;
        }
      },
      actionComplete: function (args) {
        const d = tagsSel.ids.slice(0);
        tagsSel.service = true;
        if (d.length !== 0) {
          for (let i = 0; i < this.model.currentViewData.length; i++) {
            for (let j = 0; j < d.length; j++) {
              if (d[j] === this.model.currentViewData[i].slug) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if (args.requestType === 'paging') {
                  tagsSel.page = args.currentPage;
                  tagsSel.pids = this.model.currentViewData[i].slug;
                }
                else if (args.requestType === 'refresh') {
                  tagsSel.page = 1;
                  tagsSel.pids = this.model.currentViewData[i].slug;
                }
              }
            }
          }
        }
        tagsSel.service = false;
      }
    }).data('ejGrid');

    const authorsGrid = $('#authorsGrid').ejGrid({
      dataSource: dmAuth,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: options.itemsPerPage
      },
      columns: [
        {field: 'id', headerText: 'ID', textAlign: ej.TextAlign.Right, width: 70},
        {field: 'title', headerText: localeStrings.name, width: 480},
        {field: 'slug', headerText: localeStrings.slug, width: 250}
      ],
      rowSelected: function (args) {
        if (!authSel.service) {
          authSel.page = args.model.pageSettings.currentPage;
          const d = authSel.pids[authSel.page].slice(0);
          const cr = d.indexOf(args.data.slug);
          if (cr > -1) authSel.removePid(args.data.slug);
          else authSel.pids = args.data.slug;
        }
      },
      actionComplete: function (args) {
        const d = authSel.ids.slice(0);
        authSel.service = true;
        if (d.length !== 0) {
          for (let i = 0; i < this.model.currentViewData.length; i++) {
            for (let j = 0; j < d.length; j++) {
              if (d[j] === this.model.currentViewData[i].slug) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if (args.requestType === 'paging') {
                  authSel.page = args.currentPage;
                  authSel.pids = this.model.currentViewData[i].slug;
                }
                else if (args.requestType === 'refresh') {
                  authSel.page = 1;
                  authSel.pids = this.model.currentViewData[i].slug;
                }
              }
            }
          }
        }
        authSel.service = false;
      }
    }).data('ejGrid');

    const taxGrid = $('#taxGrid').ejGrid({
      dataSource: dmTax,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: options.itemsPerPage
      },
      columns: [
        {field: 'id', headerText: 'ID', textAlign: ej.TextAlign.Right, width: 70},
        {field: 'title', headerText: localeStrings.termName, width: 480},
        {field: 'ctax_name', headerText: localeStrings.ctName, width: 250},
        {field: 'slug', headerText: localeStrings.slug, visible: false}
      ],
      rowSelected: function (args) {
        if (!taxSel.service) {
          taxSel.page = args.model.pageSettings.currentPage;
          const d = taxSel.pids[taxSel.page].slice(0);
          const cr = d.indexOf(args.data.slug);
          if (cr > -1) taxSel.removePid(args.data.slug);
          else taxSel.pids = args.data.slug;
        }
      },
      actionComplete: function (args) {
        const d = taxSel.ids.slice(0);
        taxSel.service = true;
        if (d.length !== 0) {
          for (let i = 0; i < this.model.currentViewData.length; i++) {
            for (let j = 0; j < d.length; j++) {
              if (d[j] === this.model.currentViewData[i].slug) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if (args.requestType === 'paging') {
                  taxSel.page = args.currentPage;
                  taxSel.pids = this.model.currentViewData[i].slug;
                }
                else if (args.requestType === 'refresh') {
                  taxSel.page = 1;
                  taxSel.pids = this.model.currentViewData[i].slug;
                }
              }
            }
          }
        }
        taxSel.service = false;
      }
    }).data('ejGrid');

    const typesGrid = $('#typesGrid').ejGrid({
      dataSource: dmTypes,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      //allowPaging: true,
      //pageSettings: {
      //  pageSize: options.itemsPerPage
      //},
      columns: [
        {field: 'title', headerText: localeStrings.ctt, width: 480},
        {field: 'slug', headerText: localeStrings.ctSlug, width: 250}
      ],
      rowSelected: function (args) {
        if (!typesSel.service) {
          typesSel.page = args.model.pageSettings.currentPage;
          const d = typesSel.pids[typesSel.page].slice(0);
          const cr = d.indexOf(args.data.slug);
          if (cr > -1) typesSel.removePid(args.data.slug);
          else typesSel.pids = args.data.slug;
        }
      },
      actionComplete: function (args) {
        const d = typesSel.ids.slice(0);
        typesSel.service = true;
        if (d.length !== 0) {
          for (let i = 0; i < this.model.currentViewData.length; i++) {
            for (let j = 0; j < d.length; j++) {
              if (d[j] === this.model.currentViewData[i].slug) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if (args.requestType === 'paging') {
                  typesSel.page = args.currentPage;
                  typesSel.pids = this.model.currentViewData[i].slug;
                }
                else if (args.requestType === 'refresh') {
                  typesSel.page = 1;
                  typesSel.pids = this.model.currentViewData[i].slug;
                }
              }
            }
          }
        }
        typesSel.service = false;
      }
    }).data('ejGrid');

    $('#cancel-posts').on('click', () => (postsDialog.close()));
    $('#select-posts').on('click', () => {
      posts.val(postsSel.sid);
      postsDialog.close();
    });

    $('#showPosts').on('click', (e) => {
      e.preventDefault();
      postsSel.sid = posts.val();
      postsGrid.refreshContent();
      postsDialog.open();
    });

    $('#cancel-cats').on('click', (e) => (catsDialog.close()));

    $('#select-cats').on('click', () => {
      cats.val(catsSel.sid);
      catsDialog.close();
    });

    $('#showCats').on('click', (e) => {
      e.preventDefault();
      catsSel.sid = cats.val();
      catsGrid.refreshContent();
      catsDialog.open();
    });

    $('#cancel-tags').on('click', (e) => (tagsDialog.close()));

    $('#select-tags').on('click', () => {
      tags.val(tagsSel.sid);
      tagsDialog.close();
    });

    $('#showTags').on('click', (e) => {
      e.preventDefault();
      tagsSel.sid = tags.val();
      tagsGrid.refreshContent();
      tagsDialog.open();
    });

    $('#cancel-authors').on('click', () => {
      authorsDialog.close();
    });

    $('#select-authors').on('click', () => {
      authors.val(authSel.sid);
      authorsDialog.close();
    });

    $('#showAuthors').on('click', (e) => {
      e.preventDefault();
      authSel.sid = authors.val();
      authorsGrid.refreshContent();
      authorsDialog.open();
    });

    $('#cancel-tax').on('click', () => (taxDialog.close()));

    $('#select-tax').on('click', () => {
      taxes.val(taxSel.sid);
      taxDialog.close();
    });

    $('#showTaxes').on('click', (e) => {
      e.preventDefault();
      taxSel.sid = taxes.val();
      taxGrid.refreshContent();
      taxDialog.open();
    });

    $('#cancel-types').on('click', () => (typesDialog.close()));

    $('#select-types').on('click', () => {
      types.val(typesSel.sid);
      typesDialog.close();
    });

    $('#showTypes').on('click', (e) => {
      e.preventDefault();
      typesSel.sid = types.val();
      typesGrid.refreshContent();
      typesDialog.open();
    });

    // Schedule
    const sdate = $('#sdate');
    const fdate = $('#fdate');
    const startDate = $('#startDate').ejDateTimePicker({
      width: 250,
      locale: ejLocale,
      buttonText: options.buttonText,
      dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
      timeDisplayFormat: 'HH:mm:ss',
      value: sdate.val(),
      change: function (args) {
        sdate.val(args.value);
      }
    }).data('ejDateTimePicker');
    const finishDate = $('#finishDate').ejDateTimePicker({
      width: 250,
      locale: ejLocale,
      buttonText: options.buttonText,
      dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
      timeDisplayFormat: 'HH:mm:ss',
      value: fdate.val(),
      change: function (args) {
        fdate.val(args.value);
      }
    }).data('ejDateTimePicker');

    const customUsers = $('#custom-users');
    const users = $('input:radio[name=users]');
    const regUsers = $('#x-reg-users');
    const usersReg = $('#users_reg');
    const xViewUsers = $('#x-view-users');
    const xUsers = $('#xusers');

    users.on('click', () => {
      const uval = parseInt($('input:radio[name=users]:checked').val(), 10);
      if(uval === 0) customUsers.hide('blind', {direction:'vertical'}, 500);
      else customUsers.show('blind', {direction:'vertical'}, 500);
    });

    usersReg.on('click', () => {
      if(usersReg.is(':checked')) regUsers.show('blind', {direction:'vertical'}, 500);
      else regUsers.hide('blind', {direction:'vertical'}, 500);
    });

    xUsers.on('click', () => {
      if(xUsers.is(':checked')) xViewUsers.show('blind', {direction:'vertical'}, 500);
      else xViewUsers.hide('blind', {direction:'vertical'}, 500);
    });

    const xvUsers = $('#xvusers');
    const xvUsersSel = new Selectors();
    xvUsersSel.sid = xvUsers.val();

    const usersDialog = $('#usersDialog').ejDialog(dlgOptions).data('ejDialog');

    const usersUri = '&subscriber=' + encodeURI(opts.subscriber) + '&contributor=' + encodeURI(opts.contributor) +
      '&author=' + encodeURI(opts.author) + '&editor=' + encodeURI(opts.editor) + '&admin=' + encodeURI(opts.admin) +
      '&sadmin=' + encodeURI(opts.superAdmin);

    const dmUsers = ej.DataManager({
      url: `${ajaxurl}?action=load_users&sam_pro_nonce=${options.samProNonce}${usersUri}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });

    const usersGrid = $('#usersGrid').ejGrid({
      dataSource: dmUsers,
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Multiple,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: options.itemsPerPage
      },
      columns: [
        {field: 'id', headerText: 'ID', textAlign: ej.TextAlign.Right, width: 70},
        {field: 'title', headerText: localeStrings.display, width: 330},
        {field: 'slug', headerText: localeStrings.user, width: 250},
        {field: 'role', headerText: localeStrings.role, width: 150}
      ],
      rowSelected: function (args) {
        if (!xvUsersSel.service) {
          xvUsersSel.page = args.model.pageSettings.currentPage;
          const d = xvUsersSel.pids[xvUsersSel.page].slice(0);
          const cr = d.indexOf(args.data.slug);
          if (cr > -1) xvUsersSel.removePid(args.data.slug);
          else xvUsersSel.pids = args.data.slug;
        }
      },
      actionComplete: function (args) {
        const d = xvUsersSel.ids.slice(0);
        xvUsersSel.service = true;
        if (d.length !== 0) {
          for (let i = 0; i < this.model.currentViewData.length; i++) {
            for (let j = 0; j < d.length; j++) {
              if (d[j] === this.model.currentViewData[i].slug) {
                this.multiSelectCtrlRequest = true;
                this.selectRows(i);
                if (args.requestType === 'paging') {
                  xvUsersSel.page = args.currentPage;
                  xvUsersSel.pids = this.model.currentViewData[i].slug;
                }
                else if (args.requestType === 'refresh') {
                  xvUsersSel.page = 1;
                  xvUsersSel.pids = this.model.currentViewData[i].slug;
                }
              }
            }
          }
        }
        xvUsersSel.service = false;
      }
    }).data('ejGrid');

    $('#cancel-users').on('click', () => (usersDialog.close()));

    $('#select-users').on('click', () => {
      xvUsers.val(xvUsersSel.sid);
      usersDialog.close();
    });

    $('#showXUsers').on('click', (e) => {
      e.preventDefault();
      xvUsersSel.sid = xvUsers.val();
      usersGrid.refreshContent();
      usersDialog.open();
    });

    // Advertisers
    const advs = options.advertisers;
    const advertDialog = $('#advertsDialog').ejDialog(dlgOptions).data('ejDialog');
    const advertsGrid = $('#advertsGrid').ejGrid({
      dataSource: ej.DataManager(advs),
      locale: ejLocale,
      allowSorting: true,
      allowSelection: true,
      allowFiltering: true,
      filterSettings: {filterType: 'menu'},
      selectionType: ej.Grid.SelectionType.Single,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      allowPaging: true,
      pageSettings: {
        pageSize: options.itemsPerPage
      },
      columns: [
        {field: 'owner', headerText: localeStrings.nick},
        {field: 'owner_name', headerText: localeStrings.display},
        {field: 'owner_mail', headerText: localeStrings.mail}
      ]
    }).data('ejGrid');

    $('#select-adverts').on('click', function() {
      const sr = advertsGrid.model.selectedRecords;
      if(sr.length === 1) {
        const sr00 = sr[0];
        $('#owner').val(sr00.owner);
        $('#owner_name').val(sr00.owner_name);
        $('#owner_mail').val(sr00.owner_mail);
      }
      advertDialog.close();
    });

    $('#cancel-adverts').on('click', () => (advertDialog.close()));

    $('#showAdvertisers').on('click', (e) => {
      e.preventDefault();
      advertDialog.open();
    });



    // SWF Ads
    const cbSWF = $('#swf');
    const rcSWF = $('#swf-params');
    const iLink = $('#link');
    //const iAlt = $('#alt');

    cbSWF.on('click', () => {
      if(cbSWF.is(':checked')) {
        rcSWF.show('blind', {direction:'vertical'}, 500);
      }
      else {
        rcSWF.hide('blind', {direction:'vertical'}, 500);
      }
    });

    let iLinkVal;
    const clickTag = $('#click-tag');
    const swfVars = $('#swf_vars');

    iLink.on('change', () => {
      if(this.value === '') clickTag.prop('disabled', true);
      else clickTag.prop('disabled', false);
    });

    clickTag.on('click', (e) => {
      e.preventDefault();

      const varsVal = swfVars.val();
      iLinkVal = iLink.val();
      if('' === varsVal) swfVars.val('{clickTAG: escape("' + iLinkVal + '")}');
      else {
        //varsVal.replace('}', ', clickTAG: escape("' + iLinkVal + '")}');
        swfVars.val(varsVal.replace('}', ', clickTAG: escape("' + iLinkVal + '")}'));
      }
      iLink.val('');
    });
  });
})(jQuery);
